import React, { useMemo } from 'react';
import { SplitFactoryProvider } from '@splitsoftware/splitio-react';
import { useAuth } from '../AuthContext/AuthContext';
import appSettings from '../../../appSettings';
import { getHarnessTrafficKey } from '../../../utils/harnessTrafficKey';

interface SplitProviderProps {
  children: React.ReactNode;
}

const SplitProvider: React.FC<SplitProviderProps> = ({ children }) => {
  const { userData } = useAuth();
  const splitKey = getHarnessTrafficKey(userData?.profile);

  const config = useMemo<SplitIO.IBrowserSettings>(
    () => ({
      core: {
        authorizationKey: appSettings.HARNESSKEY || 'localhost',
        key: splitKey,
      },
    }),
    [splitKey],
  );

  return (
    <SplitFactoryProvider config={config}>{children}</SplitFactoryProvider>
  );
};

export default SplitProvider;
